import { convertToFormData } from 'helper/convert_obj_to_form_data';
import client from './config'

//////////////// videos ////////////////
const url = 'index_videos';
export const getVideosRequest = () => client.get(url);

export const updateVideosRequest = (values, onUploadProgress) => {
    return client.post(`${url}`, convertToFormData(values), {
        onUploadProgress: (progress) =>
          onUploadProgress((progress.loaded / progress.total) * 100),
      });
}